module.exports = __webpack_public_path__ + "img/liveMigration.3ba77e3.svg";